import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConstants } from 'src/app/app.constants';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { User } from 'src/app/shared/models/user.model';
import { FILE_BLOB_TYPE, FILE_EXTENSION_TYPE, UserRoles } from 'src/app/app.constants';
import * as FileSaver from 'file-saver';
import { DataSourceService } from 'src/app/services/data-source.service';
import { ReportService } from 'src/app/services/report.service';
import { MatDialog } from '@angular/material/dialog';
import { MassCommunicationsComponent } from 'src/app/admin/mass-communications/mass-communications.component';
import moment from 'moment';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent {
  userRoleType: boolean = true;
  private unsubscribe: Subject<void> = new Subject<void>();
  displayOpenOrdersComponent: boolean = false;
  displayAuditReportMenu: boolean = false;
  appSettingsTag: boolean = false;
  isShowLoader: boolean;
  isAppSettingsClick = true;
  isSuperAdminAvailable: boolean;
  displayMaterialCertReportMenu: boolean = false;  
  displayReportMenu: boolean = false;
  qrCodeScanVisible: boolean;

  constructor(private userRepositoryService: UserRepositoryService, private reportService: ReportService,
    private dialog: MatDialog,) { }
  
  ngOnInit() {
    this.userRepositoryService.loggedUserData$.pipe(
      takeUntil(this.unsubscribe)).subscribe((user: User) => {
        if (user.roleId === AppConstants.Admin || user.roleId === AppConstants.Supplier || user.roleId === AppConstants.SupplyChain || 
          user.roleId === AppConstants.SUPPLIER_AP || user.roleId === AppConstants.SUPPLIER_ENG_QUALITY || user.roleId === AppConstants.SUPPLIER_SHIPPING) {
          this.displayOpenOrdersComponent = true;
        }
        if(user.roleId === AppConstants.Admin || user.roleId ===  AppConstants.SupplyChain) {
          this.displayAuditReportMenu = true;
        }
        if(user.roleId === AppConstants.Admin || user.roleId === AppConstants.SupplyChain || user.isSuperAdmin ){
          this.displayReportMenu = true;
        }
        if(user.roleId === AppConstants.Admin || user.roleId === AppConstants.SupplyChain || user.isSuperAdmin || user.roleId === AppConstants.Receiving || user.roleId === AppConstants.Logistics ) {
          this.displayMaterialCertReportMenu = true;
        }
        if(user.roleId === AppConstants.Admin || user.roleId === AppConstants.SupplyChain){
          this.qrCodeScanVisible = true;
        }
        if (user && user.roleId=== 1) {
          this.userRoleType = false;
        }
        if (user && user.isSuperAdmin && user.roleId !== 1) {
          this.userRoleType = false;
          this.isSuperAdminAvailable = true;
        }
      });
      this.registerCloseAppSettingsDrawer();
  }
  
  exportActionAuditReport() {
    const CURRENT_DATE = moment().format('DDMMMYYYY').toUpperCase(); 
    this.reportService
      .exportAuditData()
      .pipe(
        takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {        
          const data: Blob = new Blob([response], {
            type: FILE_BLOB_TYPE.XLSX
          });
          this.isShowLoader = false;
          FileSaver.saveAs(data, "Action Audit Report_"+CURRENT_DATE+ FILE_EXTENSION_TYPE.XLSX);
        }
      );
      this.isShowLoader = true;
  } 
  
  exportMaterialCertData() {
    const currentDate = moment().format('DDMMMYYYY').toUpperCase(); 
    this.reportService
      .exportMaterialData()
      .pipe(
        takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {        
          const data: Blob = new Blob([response], {
            type: FILE_BLOB_TYPE.XLSX
          });
            this.isShowLoader = false;
          FileSaver.saveAs(data, "Material Cert Report_" +currentDate+ FILE_EXTENSION_TYPE.XLSX);
        }
      );
       this.isShowLoader = true;
  } 

  exportSupplierReport() {
    const currentDate = moment().format('MMDDYYYY').toUpperCase(); 
    this.reportService
      .exportSupplierReport()
      .pipe(
        takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {        
          const data: Blob = new Blob([response], {
            type: FILE_BLOB_TYPE.XLSX
          });
            this.isShowLoader = false;
          FileSaver.saveAs(data, "Suppliers Report_" +currentDate+ FILE_EXTENSION_TYPE.XLSX);
        }
      );
       this.isShowLoader = true;
  } 
  exportUserReport() {
    const currentDate = moment().format('MMDDYYYY').toUpperCase(); 
    this.reportService
      .exportUserReport()
      .pipe(
        takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {        
          const data: Blob = new Blob([response], {
            type: FILE_BLOB_TYPE.XLSX
          });
            this.isShowLoader = false;
          FileSaver.saveAs(data, "Users Report_" +currentDate+ FILE_EXTENSION_TYPE.XLSX);
        }
      );
       this.isShowLoader = true;
  } 
  appSettingsShow(){
    this.isAppSettingsClick = !this.isAppSettingsClick;
    this.appSettingsTag = true;    
    this.userRepositoryService.closeNotification.next(true);
    this.userRepositoryService.isUploadDrawerClose.next(true);
  }

  drawerOpenClose(event) {
    this.appSettingsTag = event;
  }

  appSettingsClose(){
    this.isAppSettingsClick = !this.isAppSettingsClick;
    this.appSettingsTag = false;
    this.userRepositoryService.isUploadDrawerClose.next(false);
  }
  
  private registerCloseAppSettingsDrawer(){
    this.userRepositoryService.appSettingsClose.pipe(
      takeUntil(this.unsubscribe)).subscribe(value=>{
      if(value){
       this.appSettingsClose();
      }
    })
    }

    onMassCommunicationClick(){
      const dialogRef = this.dialog.open(MassCommunicationsComponent, {
        disableClose: true,
        width: '850px',
        data: {
          isEdit: false,
          data: null
        }
      });
      dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe))
        .subscribe(result => {
          if (result) {
            this.userRepositoryService.massCommunicationsClose.next(true);
          }
        });
    }
}
